/**
 * Application Configuration Constants
 * Centralized location for all magic numbers and configuration values
 */

// Audio Configuration
export const AUDIO_CONFIG = {
  DEFAULT_CARRIER_FREQUENCY: 200,
  MIN_CARRIER_FREQUENCY: 100,
  MAX_CARRIER_FREQUENCY: 1000,
  DEFAULT_BINAURAL_VOLUME: 15,
  DEFAULT_NOISE_VOLUME: 5,
  DEFAULT_VIDEO_VOLUME: 100,
  DEFAULT_PAN_WIDTH: 100, // Full L/R separation keeps the beat truly binaural
  MIN_GAIN_VALUE: 0.0001, // Minimum value for exponential ramp (avoids zero)
  VOLUME_TRANSITION_TIME: 0.05, // Seconds for volume changes
  NOISE_LOOP_SECONDS: 5, // Length of the pre-rendered noise loop
  NOISE_LOOP_CROSSFADE_SECONDS: 0.05, // Crossfade at the loop point to avoid clicks
  FADE_IN_VOLUME: 0.5,
  VOLUME_NORMALIZE_FACTOR: 100 // Convert from 0-100 range to 0-1 range
};

// Timer Configuration
export const TIMER_CONFIG = {
  DEFAULT_MINUTES: 30,
  DEFAULT_SECONDS: 30 * 60,
  MIN_VALUE: 0,
  MAX_HOURS: 99,
  MAX_MINUTES: 59,
  MAX_SECONDS: 59
};

// YouTube API Configuration
export const YOUTUBE_CONFIG = {
  PLAYER_HEIGHT: '100%',
  PLAYER_WIDTH: '100%',
  PLAYER_VARS: {
    autoplay: 1,
    controls: 1,
    rel: 0,
    fs: 1,
    modestbranding: 1
  },
  TITLE_FETCH_DELAY: 1000, // Milliseconds to wait before fetching video title
  DEFAULT_PLAYLIST_ID: 'PLERafrIMlGTkW1lO76qr2PQS3nQReybG8'
};

// Local Storage Keys
export const STORAGE_KEYS = {
  FAVORITES: 'binauralFavorites',
  DARK_MODE: 'binauralDarkMode'
};

// UI Configuration
export const UI_CONFIG = {
  DAILY_TITLE_MAX_LENGTH: 20,
  DAILY_TITLE_TRUNCATE_LENGTH: 15
};

// Volume Control Configuration
export const VOLUME_CONFIG = {
  MIN: 0,
  MAX: 100,
  STEP: 1,
  NORMALIZE_FACTOR: 100 // Convert from 0-100 range to 0-1 range
};
